<template>
  <div class="flex items-center justify-center border border-secondary3 rounded relative text-sm" style="height: 46px">
    <label v-if="label" :for="name" class="absolute bg-white text-xs font-medium px-1" :class="bglabel" style="top: -0.625rem; left: 0.5rem">{{ label }}</label>
    <div v-if="value.color" class="rounded-full ml-3" :style="'height: 1.25rem; width: 1.25rem; background:'+value.color"></div>
    <v-select
      :id="name"
      :name="name"
      class="custom-select font-medium w-full bg-transparent border-0 pr-2 pt-1 rounded focus:outline-none"
      style="padding-left: 2px; text-transform: capitalize;"
      v-model="selected"
      :options="options"
      :placeholder="placeholder"
      :components="{OpenIndicator, Deselect}"
      :disabled="disabled"
    />
  </div>
</template>

<script>
export default {
  name: "CustomSelect",
  props: {
    value: { type: Object, required: false, default: () => { return { label: "", code: "" } } },
    width: { type: String, required: false, default: "100%" },
    label: { type: String, required: false },
    bglabel: { type: String, required: false, default: "bg-white" },
    options: { type: Array, required: false },
    disabled: { type: Boolean, required: false, default: false },
    deselect: { type: Boolean, required: false, default: false },
    placeholder: { type: String, required: false }
  },
  data() {
    return {
      Deselect: {
        render: createElement => createElement("span", this.deselect ? "✕" : "")
      },
      OpenIndicator: {
        render: createElement => createElement("span", "⏷")
      }
    }
  },
  computed: {
    selected: {
      get() {
        return this.value.label
      },
      set(newValue) {
        this.$emit("update:value", newValue)
      }
    },
    name() {
      if (this.label) return this.label.replace(" ", "-").toLowerCase()
      else return this.value.label.replace(" ", "-").toLowerCase()
    }
  }
}
</script>

<style>
  .custom-select .vs__search::placeholder,
  .custom-select .vs__dropdown-toggle {
    border: none;
  }
  .custom-select .vs__dropdown-menu {
    margin-top: 0.75rem;
    border-radius: 5px;
    padding: 0;
    box-shadow: #1C1B1F;
    max-height: 128px;
    overflow: auto;
  }
  .custom-select .vs__dropdown-menu li{
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .custom-select .vs__clear,
  .custom-select .vs__open-indicator {
    fill: #1C1B1F;
  }
</style>



// WEBPACK FOOTER //
// src/components/CustomSelect.vue